module.exports = __webpack_public_path__ + "media/images/diy/twitter-926bb8da761f0d8ee7b19a8b38a9ce04.svg";